/* eslint-disable */
/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { CKEditor } from '@ckeditor/ckeditor5-react';
import { PsEditor as ClassicEditorBuild } from 'ckeditor5-custom-build/build/ckeditor';
import {
  initCkeditorList,
  initContextMenu,
  setCkfinderRefresh,
  setMutationObserver,
} from 'ckeditor5-custom-build/lib/ckeditorLib';
import { addCkfinderScriptTag, getCkfinderConnectorPath, initCkfinder } from 'ckeditor5-custom-build/lib/ckfinderLib';
import PathForImageToolbar from 'ckeditor5-custom-build/plugins/PathForImageToolbar';
import React, { Component } from 'react';
import { LICENSE_KEY } from '../../../../../../constants/ckeditor';
import ContextMenuPage from '../../../../productions/section/contextMenu/ContextMenuPage';
// 今後、他の言語も読み込む場合はここで読み込んでください
import { t } from 'i18next';

const STORAGE_KEY = LICENSE_KEY;

export default class CKEditorAdapter extends Component {
  constructor(props) {
    super(props);

    // console.log('props:', props);

    this.state = {
      // You need this state to render the <CKEditor /> component after the layout is ready.
      // <CKEditor /> needs the HTMLElement of the `Sidebar` plugin provided through
      // the `config` property and you have to ensure that is already rendered.
      isLayoutReady: false,
      editor: null,
      licenseKey: LICENSE_KEY,
      // ContextMenu
      contextMenuDialogIsOpen: false,
      contextMenuParams: {
        selection: null,
        element: null,
      },
      contextMenuPosition: {
        x: 0,
        y: 0,
      },
    };

    this.sidebarElementRef = React.createRef();

    this.editorContainerRef = React.createRef();
    this.viewerContainerElementRef = React.createRef();
    this.viewerEditorElementRef = React.createRef();
    this.viewerSidebarContainerElementRef = React.createRef();

    // Switch between inline and sidebar annotations according to the window size.
    this.refreshDisplayMode = this.refreshDisplayMode.bind(this);
    // Prevent closing the tab when any action is pending.
    this.checkPendingActions = this.checkPendingActions.bind(this);

    this.showEditorDataInConsole = this.showEditorDataInConsole.bind(this);
    // this.handlePsDerivationId = this.handlePsDerivationId.bind(this);
    // this.clearPsDerivationId = this.clearPsDerivationId.bind(this);

    // PS 閲覧・追加・編集画面: ダイアログで CKEditor を複数表示するので、getElementById() は使えない。
    // componentDidMount() で editorContainerRef に対して登録する。
    // const editor = window.document.getElementById('ckeditor');
    // editor.addEventListener('click', this.handlePsDerivationId);
    // editor.addEventListener('keydown', this.handlePsDerivationId);

    window.addEventListener('resize', this.refreshDisplayMode);
    window.addEventListener('beforeunload', this.checkPendingActions);

    // CKFinder
    this.ckfinderConnectorPath = getCkfinderConnectorPath();
  }

  // 右クリックメニュー
  setContextMenuDialogIsOpen = (isOpen) => {
    this.setState({ contextMenuDialogIsOpen: isOpen });
  };
  setContextMenuParams = (params) => {
    this.setState({ contextMenuParams: params });
  };

  /**
   * api処理中
   */
  setApiProcessing = (apiProcessing) => {
    this.props.setApiProcessing(apiProcessing);
  };

  componentDidMount() {
    // イベント リスナーを追加。
    // this.editorContainerRef.current.addEventListener('click', this.handlePsDerivationId);
    // this.editorContainerRef.current.addEventListener('keydown', this.handlePsDerivationId);

    window.CKBox = ClassicEditorBuild.CKBox;
    // console.log(ClassicEditorBuild.defaultConfig);

    const licenseKey = LICENSE_KEY;

    this.setState({
      // When the layout is ready, you can switch the state and render the `<CKEditor />` component.
      isLayoutReady: true,
      // Save the provided license key in the local storage.
      licenseKey,
    });

    window.localStorage.setItem(STORAGE_KEY, licenseKey);

    // CKFinder
    initCkfinder(this.ckfinderConnectorPath);
  }

  componentWillUnmount() {
    // this.clearPsDerivationId();

    // イベント リスナーを削除。
    // this.editorContainerRef.current.removeEventListener('click', this.handlePsDerivationId);
    // this.editorContainerRef.current.removeEventListener('keydown', this.handlePsDerivationId);

    // window.removeEventListener('click', this.handlePsDerivationId);
    // window.removeEventListener('keydown', this.handlePsDerivationId);
    window.removeEventListener('resize', this.refreshDisplayMode);
    window.removeEventListener('beforeunload', this.checkPendingActions);
  }

  /**
   * オブジェクト内の特定の名前の項目を処理する。
   * @param obj 対象オブジェクト。
   * @param name 名前。
   * @param process 処理関数。
   */
  processProperty = (obj, name, process) => {
    Object.keys(obj).forEach((key) => {
      if (key === name) {
        process(obj, key);
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        this.processProperty(obj[key], name, process);
      }
    });
  };

  // コピーしたJSON上に埋め込まれる情報
  CLIPBOARD_DATA_TYPE = 'ckeditor5.element';
  CLIPBOARD_DATA_TYPE_PS = 'ckeditor5.element.ps';

  /**
   * PSの種別。
   */
  PSTYPE_ROOT = 0;
  PSTYPE_CHAPTER = 1;
  PSTYPE_TITLE = 2;
  PSTYPE_CONTENTS = 3;

  /**
   * heading?系のノードを取得して返す。
   * @returns
   */
  getHeadingNode = (targetNode) => {
    if (!targetNode) {
      return null;
    }

    if (/^htmlH\d$/.test(targetNode.name)) {
      return targetNode;
    }

    if (targetNode.is('$text')) {
      return null;
    }

    var result = null;
    targetNode.getChildren().forEach((element) => {
      if (!result) {
        result = this.getHeadingNode(element);
      }
    });

    return result;
  };

  /**
   * クリップボード用のデータからheading?系のノードを取得して返す。
   * @returns
   */
  getHeadingNodeForClipboardData = (targetNode) => {
    if (!targetNode) {
      return null;
    }

    // <div class="title"><h?></h?></div>の場合、タイトルと見なして内部のヘッダ要素を返す
    if (/^htmlDiv$/.test(targetNode.name)) {
      if (targetNode.attributes.htmlDivAttributes && targetNode.attributes.htmlDivAttributes.classes) {
        if (targetNode.attributes.htmlDivAttributes.classes.includes('title')) {
          if (targetNode.children && targetNode.children.length === 1) {
            if (/^heading\d$/.test(targetNode.children[0].name)) {
              return targetNode.children[0];
            }
          }
        }
      }
    }

    if (/^heading\d$/.test(targetNode.name)) {
      return targetNode;
    }

    if (targetNode.children) {
      var result = null;
      targetNode.children.forEach((element) => {
        if (!result) {
          result = this.getHeadingNodeForClipboardData(element);
        }
      });

      return result;
    }

    return null;
  };

  /**
   * コピーボタンクリックイベントハンドラ。
   */
  onPsCopy = () => {
    if (!this.state.editor) {
      return;
    }

    const editor = this.state.editor;

    // 対象ノードを取得
    var targetNodes = [];
    editor.model.document
      .getRoot()
      .getChildren()
      .forEach((element) => {
        targetNodes.push(element);
      });

    // タイトルPSの場合、h?要素を検索して置き換える
    if (Number(this.props.psType) == this.PSTYPE_TITLE) {
      const replaceTargetNodes = [];
      targetNodes.forEach((element) => {
        const headingElement = this.getHeadingNode(element);
        if (headingElement) {
          replaceTargetNodes.push(headingElement);
        } else {
          replaceTargetNodes.push(element);
        }
      });
      targetNodes = replaceTargetNodes;
    }

    // ラップ要素で包む
    const currentElementData = JSON.stringify(targetNodes).replace(
      /\"name\":\"htmlH\d\"/g,
      `"name":"heading${this.props.psLevel}"`
    );
    const wrappedElementData = '{"name":"htmlDiv","attributes":{},"children":' + currentElementData + '}';
    var tempElement = JSON.parse(wrappedElementData);

    // プロパティを追加
    tempElement.attributes.htmlDivAttributes = {};
    if (Number(this.props.psType) == this.PSTYPE_TITLE) {
      tempElement.attributes.htmlDivAttributes.classes = ['title'];
    }
    tempElement.attributes.htmlDivAttributes.attributes = {};
    tempElement.attributes.htmlDivAttributes.attributes.ps_no = String(this.props.psNo ?? '');
    tempElement.attributes.htmlDivAttributes.attributes.ps_version_id = String(this.props.psVersionId ?? '');
    tempElement.attributes.htmlDivAttributes.attributes.ps_derivation_id = String(this.props.psDerivationId ?? '');
    tempElement.attributes.htmlDivAttributes.attributes.fsr_id = String(this.props.fsrId ?? '');
    tempElement.attributes.htmlDivAttributes.attributes.confirmed = '0';

    // blob用JSON文字列作成
    const copyData = { type: this.CLIPBOARD_DATA_TYPE_PS, psType: this.props.psType, data: [] };
    copyData.data.push(tempElement);
    const blobData = JSON.stringify(copyData);

    navigator.clipboard
      .write([
        new ClipboardItem({
          'text/plain': new Blob([blobData], { type: 'text/plain' }),
        }),
      ])
      .catch((error) => {
        console.log(`Failed to copy: ${error}`);
      });
  };

  /**
   * データを元にElementまたはTextを生成して返す。
   * @param writer Writerオブジェクト。
   * @param data データ。
   * @returns 生成されたElementまたはTextオブジェクト。
   */
  createElementByData = (writer, data) => {
    let resultElement = undefined;
    if (data.name) {
      resultElement = writer.createElement(data.name);
    } else if (data.data) {
      resultElement = writer.createText(data.data);
    } else {
      return undefined;
    }

    if (data.attributes) {
      const keys = Object.keys(data.attributes);
      for (const key of keys) {
        // PS系の属性は削除
        if (key === 'htmlDivAttributes' && data.attributes[key]['attributes']) {
          delete data.attributes[key]['attributes']['title'];
          delete data.attributes[key]['attributes']['ps_no'];
          delete data.attributes[key]['attributes']['ps_version_id'];
          delete data.attributes[key]['attributes']['ps_derivation_id'];
          delete data.attributes[key]['attributes']['fsr_id'];
          delete data.attributes[key]['attributes']['confirmed'];
        }
        writer.setAttribute(key, data.attributes[key], resultElement);
      }
    }

    if (data.children) {
      for (const childData of data.children) {
        const child = this.createElementByData(writer, childData);
        if (child) {
          writer.insert(child, resultElement, 'end');
        }
      }
    }

    return resultElement;
  };

  /**
   * ペーストデータの種別を取得する。
   * @param data ペーストデータ。
   * @returns ペーストデータの種別。
   *         -1: 不明
   *          0: ルート
   *          1: 章
   *          2: タイトル
   *          3: 内容
   */
  getPasteType = (data) => {
    if (data.data.length != 1) {
      return -1;
    }

    switch (data.psType) {
      case this.PSTYPE_TITLE:
        return this.PSTYPE_TITLE;

      case this.PSTYPE_CONTENTS:
        return this.PSTYPE_CONTENTS;

      default:
        return -1;
    }
  };

  /**
   * ペーストボタンクリックイベントハンドラ。
   */
  onPsPaste = () => {
    if (!this.state.editor) {
      return;
    }

    const editor = this.state.editor;

    navigator.clipboard
      .readText()
      .then((text) => {
        try {
          const data = JSON.parse(text);

          if (data.type !== this.CLIPBOARD_DATA_TYPE) {
            console.log('The data to be pasted is not applicable.');
            return;
          }

          // ペースト可能かどうかを判定
          var pasteType = this.getPasteType(data);
          if (pasteType !== Number(this.props.psType)) {
            console.log(
              'Cannot paste because the types are different. (pasteType:',
              pasteType,
              ', psType:',
              this.props.psType,
              ')'
            );
            return;
          }

          const targetNode = editor.model.document.getRoot();

          // ペースト前の状態が空の要素だけの場合、この段階では削除できないので、後で削除するためのフラグを立てる
          var doRemoveFirstChild = false;
          if (targetNode.childCount === 1) {
            const firstChild = targetNode.getChild(0);
            if (firstChild.childCount === 0) {
              doRemoveFirstChild = true;
            }
          }

          switch (pasteType) {
            case this.PSTYPE_TITLE:
              if (this.props.psLevel) {
                this.processProperty(data.data[0], 'name', (obj, key) => {
                  if (/^heading\d$/.test(obj[key])) {
                    obj[key] = `heading3`;
                  }
                });
              }

              const headingNode = this.getHeadingNodeForClipboardData(data.data[0]);
              if (headingNode) {
                editor.model.change((writer) => {
                  const elementToPaste = this.createElementByData(writer, headingNode);
                  if (elementToPaste) {
                    writer.append(elementToPaste, targetNode);
                  }

                  // ペースト前の状態が空の要素だけの場合、最初の要素を削除
                  if (doRemoveFirstChild) {
                    writer.remove(targetNode.getChild(0));
                  }
                });
              }
              break;

            case this.PSTYPE_CONTENTS:
              if (
                data.data[0].name == 'htmlDiv' &&
                data.data[0].attributes?.htmlDivAttributes?.classes?.includes('contents')
              ) {
                console.log("'div.contents' cannot be pasted.");
                return;
              }
              var dataToPaste = data.data;
              // psのDiv要素がルートになっている場合、その子要素をペースト対象とする
              if (data.data[0].name == 'htmlDiv' && data.data[0].attributes?.htmlDivAttributes?.attributes?.ps_no) {
                dataToPaste = data.data[0].children;
              }
              if (dataToPaste && Array.isArray(dataToPaste)) {
                editor.model.change((writer) => {
                  dataToPaste.forEach((element) => {
                    const elementToPaste = this.createElementByData(writer, element);
                    if (elementToPaste) {
                      writer.append(elementToPaste, targetNode);
                    }
                  });

                  // ペースト前の状態が空の要素だけの場合、最初の要素を削除
                  if (doRemoveFirstChild) {
                    writer.remove(targetNode.getChild(0));
                  }
                });
              }
              break;

            default:
              console.log(`Unknown paste type: ${pasteType}`);
              break;
          }
        } catch (error) {
          console.log(error);
        }
      })
      .catch((reason) => {
        console.log("Can't read clipboard.", reason);
      });
  };

  render() {
    // if (this.state.editor) {
    //   if (this.props.data.argThreadId) {
    //     const commentsRepository = this.state.editor.plugins.get('CommentsRepository');
    //     const commentThread = commentsRepository.getCommentThread(this.props.data.argThreadId);
    //     const comment = commentThread.getComment(this.props.data.argCommentId);
    //     comment.content += `<p><a href="${this.props.data.argCommentURL}" target="_blank">${this.props.data.argFileName}</a></p>`;
    //     this.props.data.argThreadId = '';
    //   }
    // }

    return (
      <div className="App">
        <main>
          <div className="centered">{this.renderEditor()}</div>
        </main>
      </div>
    );
  }

  renderEditor() {
    // console.log('this.props:', this.props);

    return (
      <div className="row row-editor">
        <div className="editors-holder">
          <div className="editor-container" id="editor-container" ref={this.editorContainerRef}>
            {/* Do not render the <CKEditor /> component before the layout is ready. */}
            {this.state.isLayoutReady && (
              <CKEditor
                onReady={(editor) => {
                  // console.log('onReady editor:', editor);

                  this.setState({ editor });
                  this.props.setEditor(editor);

                  window.editor = editor; // リストで使うのでマスト

                  this.refreshDisplayMode();
                  addCkfinderScriptTag();
                  setMutationObserver(editor);
                  setCkfinderRefresh();
                  initCkeditorList(editor);

                  // 右クリック
                  initContextMenu(editor, (result) => {
                    const { selection, element, mousePosition } = result;
                    const containerElement = element?.closest('.draggable-ckeditor-dialog');
                    if (containerElement) {
                      // PSではエディタをdraggableを使っているので、containerを基準にしてマウス位置を調整
                      const rect = containerElement.getBoundingClientRect();
                      mousePosition.x -= rect.left;
                      mousePosition.y -= rect.top;
                      this.setState({
                        contextMenuDialogIsOpen: true,
                        contextMenuParams: { selection, element },
                        contextMenuPosition: mousePosition,
                      });
                    }
                  });
                }}
                onBlur={(event, editor) => {
                  // console.log('onBlur event: ', event);
                  this.props.setEditor(editor);
                  // this.props.onBlur(editor);
                }}
                // onChange={(event, editor) => {
                //   const data = editor.getData();
                //   console.log('onChange:', { event, editor, data });
                // }}
                // editor={ ClassicEditorBuild.ClassicEditorWithRevisionHistory }
                editor={ClassicEditorBuild}
                config={{
                  removePlugins: ['RevisionHistory'],

                  // extraPlugins: [UsersIntegration, CommentsIntegration],
                  // extraPlugins: [
                  //   UsersIntegration,
                  //   CommentsIntegration,
                  //   TrackChangesIntegration,
                  //   RevisionHistoryIntegration,
                  // ],
                  extraPlugins: [
                    PathForImageToolbar,
                    listenChangeLink, // リファレンス
                  ],

                  customValues: {
                    // commentThreads: this.props.section.comment_thread_json
                    //   ? JSON.parse(this.props.section.comment_thread_json)
                    //   : [],
                    // revisionThreads: this.props.section.revision_json
                    //   ? JSON.parse(this.props.section.revision_json)
                    //   : [],
                    // suggestionThreads: this.props.section.edit_content.track_threads_json
                    //   ? JSON.parse(this.props.section.edit_content.track_threads_json)
                    //   : [],
                    // users: this.props.section.user_json ? JSON.parse(this.props.section.user_json) : [],
                    // user: this.props.user,
                    isOwnProduction: !this.props.isReadOnly,
                  },
                  toolbar: this.props.toolbar,
                  // sidebar: {
                  //   container: this.sidebarElementRef.current,
                  // },
                  ckfinder: {
                    options: {
                      rememberLastFolder: false,
                      startupPath: `contents:/ps/tmp`, // 初期表示ディレクトリの指定（resourceType名:フォルダへの相対パス）
                      connectorPath: this.ckfinderConnectorPath, // Laravel 側の connector エンドポイント
                      connectorInfo: 'mode=ps&user_id=' + this.props.user.user_id, // connector へ追加する独自パラメータ
                      resourceType: 'contents', // ここを設定しないと type（resourceType）が自動で「contents」にされてしまうため、空白でも必要。もしく特定のリソースタイプを明示する
                      productionId: this.props.productionId,
                      apiBasePath: process.env.REACT_APP_API_BASE_PATH,
                      messages: {
                        deleteFolderConfirm: t('削除を確認するため「削除」と入力してください。'),
                        deleteFolderKey: t('削除'),
                      },
                      plugins: 'MyPlugin',
                    },
                    // uploadUrl: '/path/to/image/upload'
                    // uploadUrl:
                    //   'http://localhost:8000/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files&responseType=json',
                  },
                  licenseKey: LICENSE_KEY,
                  // revisionHistory: {
                  //   editorContainer: this.editorContainerRef.current,
                  //   viewerContainer: this.viewerContainerElementRef.current,
                  //   viewerEditorElement: this.viewerEditorElementRef.current,
                  //   viewerSidebarContainer: this.viewerSidebarContainerElementRef.current,
                  // },
                  // autosave: {
                  //   save: (editor) => {
                  //     const revisionTracker = editor.plugins.get('RevisionTracker');
                  //     return revisionTracker.update();
                  //   },
                  // },
                  customButtonPsCopy: {
                    onClick: [this.PSTYPE_TITLE, this.PSTYPE_CONTENTS].includes(Number(this.props.psType))
                      ? this.onPsCopy
                      : null,
                  },
                  customButtonPsPaste: {
                    onClick: [this.PSTYPE_TITLE, this.PSTYPE_CONTENTS].includes(Number(this.props.psType))
                      ? this.onPsPaste
                      : null,
                  },
                  reference: {
                    // リンク処理用config
                    languageId: this.props.languageId,
                    apiBasePath: process.env.REACT_APP_API_BASE_PATH,
                    setApiProcessing: this.setApiProcessing,
                  },
                }}
                // data={this.props.section.edit_content.xml_content}
                data={this.props.initialData}
                // data={AppData.initialData}
                disabled={this.props.isReadOnly}
                // disabled={true}
              />
            )}
            <div ref={this.sidebarElementRef} className="sidebar" style={{ display: 'none' }} />
          </div>
          <div ref={this.viewerContainerElementRef}>
            <div className="editor-container">
              <div ref={this.viewerEditorElementRef} />
              <div className="sidebar-container" ref={this.viewerSidebarContainerElementRef} />
            </div>
          </div>
        </div>
        {/* 右クリックメニュー */}
        {this.state.editor && this.state.contextMenuDialogIsOpen && (
          <ContextMenuPage
            contentType="ps"
            editor={this.state.editor}
            params={this.state.contextMenuParams}
            defaultPosition={this.state.contextMenuPosition}
            onClose={() => {
              this.setContextMenuDialogIsOpen(false);
            }}
          />
        )}
      </div>
    );
  }

  search(element, attribute) {
    if (element.hasAttribute(attribute)) {
      return element;
    } else if (
      element.getAttribute('htmlAttributes')?.attributes &&
      attribute in element.getAttribute('htmlAttributes').attributes
    ) {
      return element;
    } else {
      if (!element.parent) return null;
      return this.search(element.parent, attribute);
    }
  }
  searchPsAttribute(element) {
    return this.search(element, 'ps_derivation_id');
  }
  clearPsDerivationId() {
    if (typeof this.props.setPsDerivationId === 'function') {
      this.props.setPsDerivationId(null);
    }
  }
  handlePsDerivationId(e) {
    if (!this.state?.editor) {
      return;
    }

    if (e.key && !['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft'].includes(e.key)) return;

    const editor = this.state.editor;
    const selection = editor.model.document.selection;
    const blocks = [...selection.getSelectedBlocks()];
    // console.log(blocks);
    if (blocks[0]) {
      // ps_derivation_idとps_version_idは同一element内に存在する
      const selectElement = this.searchPsAttribute(blocks[0]);

      if (selectElement) {
        var psDerivationId = null;
        var psVersionId = null;
        if (selectElement.hasAttribute('ps_derivation_id')) {
          psDerivationId = selectElement.getAttribute('ps_derivation_id');
          psVersionId = selectElement.getAttribute('ps_version_id');
        } else {
          psDerivationId = selectElement.getAttribute('htmlAttributes')?.attributes?.ps_derivation_id;
          psVersionId = selectElement.getAttribute('htmlAttributes')?.attributes?.ps_version_id;
        }
        this.props.setPsDerivationId(Number(psDerivationId));
        this.props.setPsVersionId(Number(psVersionId));
      } else {
        this.props.setPsDerivationId(null);
        this.props.setPsVersionId(null);
      }
    } else {
      this.props.setPsDerivationId(null);
      this.props.setPsVersionId(undefined);
    }
  }
  refreshDisplayMode() {
    if (!this.state.editor) {
      return;
    }

    const annotationsUIs = this.state.editor.plugins.get('AnnotationsUIs');
    const sidebarElement = this.sidebarElementRef.current;

    if (window.innerWidth < 1070) {
      sidebarElement.classList.remove('narrow');
      sidebarElement.classList.add('hidden');
      annotationsUIs.switchTo('inline');
    } else if (window.innerWidth < 1300) {
      sidebarElement.classList.remove('hidden');
      sidebarElement.classList.add('narrow');
      annotationsUIs.switchTo('narrowSidebar');
    } else {
      sidebarElement.classList.remove('hidden', 'narrow');
      annotationsUIs.switchTo('wideSidebar');
    }
  }

  showEditorDataInConsole(evt) {
    const editorData = this.state.editor.data.get();

    // const revisionsRepositoryPlugin = this.state.editor.plugins.get('RevisionsRepository');
    // const trackChanges = this.state.editor.plugins.get('TrackChanges');
    // const comments = this.state.editor.plugins.get('CommentsRepository');

    // const revisionsData = revisionsRepositoryPlugin.getRevisions();
    // const suggestionsData = trackChanges.getSuggestions();
    // const commentThreadsData = comments.getCommentThreads({
    //   skipNotAttached: true,
    //   skipEmpty: true,
    // });

    evt.preventDefault();
  }

  checkPendingActions(domEvt) {
    if (!this.state.editor) {
      return;
    }

    if (this.state.editor.plugins.get('PendingActions').hasAny) {
      domEvt.preventDefault();
      domEvt.returnValue = true;
    }
  }
}

class UsersIntegration {
  constructor(editor) {
    this.editor = editor;
  }

  init() {
    const usersPlugin = this.editor.plugins.get('Users');

    // Load the users data.
    // for (const user of AppData.users) {
    for (const user of this.editor.config._config.customValues.users) {
      usersPlugin.addUser(user);
    }

    // Set the current user.
    // usersPlugin.defineMe(AppData.defineMe);
    usersPlugin.defineMe(String(this.editor.config._config.customValues.user.user_id));
  }
}

class CommentsIntegration {
  constructor(editor) {
    this.editor = editor;
  }

  init() {
    const commentsRepositoryPlugin = this.editor.plugins.get('CommentsRepository');

    // Load the comment threads data.
    // for (const commentThread of AppData.commentThreads) {
    for (const commentThread of this.editor.config._config.customValues.commentThreads) {
      commentsRepositoryPlugin.addCommentThread(commentThread);
    }

    // set ReadOnly
    // AppData.commentThreads.forEach((element) => {
    this.editor.config._config.customValues.commentThreads.forEach((element) => {
      if (element.isComplete === 0) {
        const thread = commentsRepositoryPlugin.getCommentThread(element.threadId);
        thread.isReadOnly = true;
      }
    });
  }
}

class TrackChangesIntegration {
  constructor(editor) {
    this.editor = editor;
  }

  init() {
    const trackChangesPlugin = this.editor.plugins.get('TrackChanges');

    // Load the suggestions data.
    for (const suggestion of this.editor.config._config.customValues.suggestionThreads) {
      // for (const suggestion of AppData.trackThreads) {
      trackChangesPlugin.addSuggestion(suggestion);
    }
  }
}

class RevisionHistoryIntegration {
  constructor(editor) {
    this.editor = editor;
  }

  static get requires() {
    return ['RevisionHistory'];
  }

  init() {
    const revisionHistory = this.editor.plugins.get('RevisionHistory');

    // Load revisions data
    for (const revisionData of this.editor.config._config.customValues.revisionThreads) {
      // for (const revisionData of AppData.revisionHistory) {
      revisionHistory.addRevisionData(revisionData);
    }
  }
}

// リンクHrefの変更検知
class listenChangeLink {
  constructor(editor) {
    this.editor = editor;
  }
  init() {
    const editor = this.editor;

    // http://localhost:3000/ja/ps/view/26792
    // イベント
    // リンクボタンを押す、もしくは既存のリンクをクリックする ⇒ LinkFormViewが表示される。
    // ⇒ 保存ボタン(submit)を押す ⇒ ckeditor上でリンクが作成される ★この時点でのイベントを拾う
    editor.commands.get('link').on('execute', (evt, data) => {
      /*
      console.log('Link added/Edit');
      console.log(evt, data);
      console.log(data);
      */
      refernceUpdater.onReferenceUpdateOnce(editor);
    });
  }
}

/**
 * リンク更新クラス
 * セクションのCkEditorAdapter.jsがベース
 */
class refernceUpdater {
  /**
   * ユーザーがリンクボタンからIDを入力した後の処理
   * @param {*} editor
   * @returns
   */
  static onReferenceUpdateOnce = (editor) => {
    if (!editor) return;

    // リンク設定
    const referenceConfig = editor.config.get('reference');
    const languageId = referenceConfig.languageId; // 言語ID
    const apiBasePath = referenceConfig.apiBasePath; // Apiベースパス
    const setApiProcessing = referenceConfig.setApiProcessing; // api処理中フラグ

    // 現在選択しているp要素を取得
    const selection = editor.model.document.selection;
    const blocks = [...selection.getSelectedBlocks()];
    const pElement = blocks[0];
    if (pElement == null) return;

    // a要素を含むp要素配列（ユーザー操作の場合、要素は1つのみ）
    let taElements = [];

    // a要素の情報を取得
    const aInfoArr = this._getAInfo(pElement);
    if (aInfoArr.length == 0) return;
    /*
    console.log('-------------------');
    console.log(pElement);
    console.log('-------------------');
    console.log('---- ATag情報 ----');
    console.log(aInfoArr);
    */

    // a要素ありの場合、情報を配列に入れる
    let item = {
      element: pElement, // p要素
      ainfo: aInfoArr, // p要素内のリンク情報配列
    };
    // 配列に格納
    taElements.push(item);

    // 非同期通信
    const apiKey = this._getApiKey(); // apiキー
    const apiTopUrl = this._getApiTopUrl(apiBasePath);
    const apiUrl = `${apiTopUrl}/pss/reference`; // apiのURL

    // apiパラメータ―作成
    const params = [];
    taElements.forEach((taElement, index) => {
      for (var aInfo of taElement.ainfo) {
        const item = {
          // production_id: productionId,

          // a_id: aInfo.a_id,
          language_id: languageId,
          reference_id: aInfo.reference_id,
          index: index, // 戻ってくるリンクxmlを親であるPタグと結びつけるためのインデックス
        };
        params.push(item);
      }
    });

    // api処理中
    setApiProcessing(true);

    // Fetch APIはブラウザに搭載された非同期処理をするための関数です
    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-KEY': apiKey },
      body: JSON.stringify({ reference_data: params }),
    })
      .then((response) => response.json()) // 返ってきたレスポンスをjsonで受け取って次のthenへ渡す
      .then((res) => {
        // 成功
        // リンクを持つPタグ毎に処理する
        this._setLinkModel(editor, res, taElements);
      })
      .catch((error) => console.error('Failed to notify.', error))
      .finally(() => {
        // api処理終了
        setApiProcessing(false);
      });
  };

  /**
   * リンクの一括更新
   * @param {*} editor
   * @param {*} productionId
   * @param {*} apiBasePath
   * @param {*} sectionId
   * @param {*} setApiProcessing
   * @returns
   */
  static onReferenceUpdate = (editor, productionId, apiBasePath, sectionId, setApiProcessing) => {
    if (!editor) {
      return;
    }

    /*
    // マーカー確認テスト
    const markers = editor.model.markers;
    const markersMap = editor.utils.toMap(markers._markers);
    for (const [key, val] of markersMap) {
      // console.log(key);
      // console.log(val.getRange());
      // console.log(val.getStart().path);
      // console.log(val.getEnd().path);
      // console.log(val.getData());
    }
    */

    // a要素を含むp要素
    let taElements = [];

    // L2内のリンク情報を取得しtaElementsに格納
    const rootEl = editor.model.document.getRoot();
    rootEl._children._nodes.forEach((element) => {
      this._getPAElement(element, taElements);
    });

    // 非同期通信
    const apiKey = this._getApiKey(); // apiキー
    const apiTopUrl = this._getApiTopUrl(apiBasePath);
    const apiUrl = `${apiTopUrl}/sections/${sectionId}/reference`; // apiのURL
    // パラメータ―作成
    const params = [];
    taElements.forEach((taElement, index) => {
      for (var aInfo of taElement.ainfo) {
        const item = {
          production_id: productionId,
          a_id: aInfo.a_id,
          reference_id: aInfo.reference_id,
          index: index, // 戻ってくるリンクxmlを親であるPタグと結びつけるためのインデックス
        };
        params.push(item);
      }
    });

    // api処理中
    setApiProcessing(true);

    // Fetch APIはブラウザに搭載された非同期処理をするための関数です
    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-KEY': apiKey },
      body: JSON.stringify({ reference_data: params }),
    })
      .then((response) => response.json()) // 返ってきたレスポンスをjsonで受け取って次のthenへ渡す
      .then((res) => {
        // console.log(res);
        // 成功
        this._setLinkModel(editor, res, taElements);
      })
      .catch((error) => {
        console.error('Failed to notify.', error);
      })
      .finally(() => {
        // api処理終了
        setApiProcessing(false);
      });
  };

  // apiからのリンクXMLでa要素を置き換える
  static _setLinkModel = (editor, res, taElements) => {
    editor.model.change((writer) => {
      for (var i = 0; i < taElements.length; i++) {
        const pElement = taElements[i].element;
        const ainfo = taElements[i].ainfo;
        // console.log(ainfo);

        // リンクのxml配列を回し、該当のxmlを見つけて入れ替える
        for (const item of res.reference_xml) {
          // インデックスが一致するもの
          if (item[0] == i) {
            const xml = item[1];

            let ainfoIdx = null; // p要素内に複数のa要素がある場合、hrefによって該当のa要素配列を取得するためのindex

            // xmlをmodelに変換
            const viewFragment = editor.data.processor.toView(xml);
            const modelFragment = editor.data.toModel(viewFragment);

            // modelFragment ⇒ modelに変換(複数の可能性)
            const textInfo = this._getTextNode(modelFragment);

            // Pタグ内の該当のAタグを見つけて入れ替える
            let rmTexts = [];
            let insertPosition = null;
            pElement._children._nodes.forEach((aElement) => {
              if (aElement.hasAttribute('linkHref')) {
                const linkHref = String(aElement.getAttribute('linkHref'));
                if (textInfo.href == linkHref) {
                  // href属性値が一致したものを置き換える
                  if (rmTexts.length == 0) {
                    writer.setSelection(aElement, 'before');
                    insertPosition = editor.model.document.selection.getFirstPosition();
                  }
                  // console.log(aElement);
                  rmTexts.push(aElement);

                  // リンク情報配列のindexを取得
                  ainfo.forEach((item, index) => {
                    if (item.reference_id == linkHref) {
                      ainfoIdx = index;
                    }
                  });
                }
              }
            });

            // 置き換えるものが存在する
            if (rmTexts.length > 0) {
              // リンク要素を削除
              for (const rmText of rmTexts) {
                writer.remove(rmText);
              }

              // 新しいものに置き換え(textが複数ある場合、逆の順で挿入する)
              //   既存のtext(a要素)の先頭から前方向に置き換えるa要素を挿入
              const reversed = textInfo.texts.reverse();
              for (const text of reversed) {
                writer.insert(text, insertPosition);
              }

              if (ainfoIdx != null) {
                // コメント情報
                const cInfo = ainfo[ainfoIdx].c_info;

                // コメントのパターンによってマーカーのレンジを操作する必要がある
                // console.log('コメントパターン：' + cInfo.pattern.toString());
                if (cInfo.pattern != 0 && cInfo.pattern != 3) {
                  let startPosition;
                  let endPosition;

                  // textを全て挿入した時点でのpositionを取得する
                  // textを挿入した時点で既存のコメントマーカーも変わる可能性もあるので、MarkersをここでKeyから取得して、Positionを取る
                  const cmMarkers = editor.model.markers;
                  const cmMarker = cmMarkers.get(cInfo.cmKey);
                  const cmStartPosition = cmMarker.getStart();
                  const cmEndPosition = cmMarker.getEnd();

                  // マーカーのパターンによってレンジを設置する
                  const lastText = reversed[0];
                  const firstText = reversed[reversed.length - 1];

                  if (cInfo.pattern == 1) {
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 2) {
                    // 内側　--->  この場合はa要素全てにマーカーを付けることにする
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 4) {
                    // 前が同じ、後ろは外
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = cmEndPosition;
                  } else if (cInfo.pattern == 5) {
                    // 前が同じ、後ろは中　--->  この場合はマーカーの後ろはa要素の後ろに合わせることにする
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 6) {
                    // 後ろが同じ、前は外
                    startPosition = cmStartPosition;
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 7) {
                    // 後ろが同じ、前は中　--->  この場合はマーカーの先頭はa要素の先頭に合わせることにする
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 8) {
                    // 前から途中まで　--->  この場合はマーカーの後ろはa要素の後ろに合わせることにする
                    startPosition = cmStartPosition;
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 9) {
                    // 途中から外まで　--->  この場合はマーカーの先頭はa要素の先頭に合わせることにする
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = cmEndPosition;
                  }

                  // コメントマーカーの更新
                  console.log('コメントマーカーを更新します。 コメントID：' + cInfo.cmKey);
                  const markerName = cInfo.cmKey;
                  const range = writer.createRange(startPosition, endPosition);
                  writer.updateMarker(markerName, { range });
                }
              }

              /*
              // リンク要素を削除
              for (const rmText of rmTexts) {
                writer.remove(rmText);
              }
              */
            }
          }
        }
      }
    });
  };

  // タグを遡ってaタグを含むpタグを取得（リンクの一括更新で使用）
  static _getPAElement = (elementPa, taElemets) => {
    // pタグのモデル名
    const pModelNames = [
      'paragraphSupplementSubhead',
      'paragraphSupplementPara',
      'paragraphReferGear',
      'warningListTitle',
      'illustHeadline',
      'customGroup',
      'customItem',
      'paragraphRefer1',
      'paragraph',
    ];

    const cmMarkers = editor.model.markers;

    if (!elementPa) return;
    if (elementPa._children && elementPa._children._nodes.length > 0) {
      // 子要素あり
      elementPa._children._nodes.forEach((element) => {
        // Pタグのモデル名と一致するか確認
        if (pModelNames.indexOf(element.name) !== -1) {
          // pタグ内のリンク(modelではText)を検索し情報を取得
          // ※ 1対N の可能性もある
          const aInfoArr = this._getAInfo(element);
          if (aInfoArr.length > 0) {
            // リンクありの場合、情報を配列に入れる
            let item = {
              element: element, // Pタグ
              ainfo: aInfoArr, // Pタグ内のリンク情報配列
            };

            // 配列に格納
            taElemets.push(item);
          }
        }
        this._getPAElement(element, taElemets);
      });
      return;
    } else {
      // 子要素なし
      return;
    }
  };

  // コメント状態の取得
  static _hasComment = (path, stOff, enOff, cmMarkers) => {
    let pt = 0;
    let cmKey = true;

    let aStPath = path.map((v) => {
      return v;
    });
    let aEnPath = path.map((v) => {
      return v;
    });
    aStPath[aStPath.length - 1] = stOff; // a要素先端位置の配列
    aEnPath[aEnPath.length - 1] = enOff; // a要素後端位置の配列
    // console.log('該当Elementのパス：' + aStPath.toString() + ', ' + aEnPath.toString());

    const markersMap = editor.utils.toMap(cmMarkers._markers);
    // console.log('マーカー');
    // console.log(markersMap);
    for (const [key, val] of markersMap) {
      // コメントマーカー以外はスキップ（前方一致ではない時）
      if (key.indexOf('comment:')) {
        continue;
      }

      // console.log('++++++ comment +++++++');
      // console.log(key);
      // console.log(val.getRange());
      // console.log(val.getData());

      // マーカーキー(コメントスレッドID)
      cmKey = key;
      const cStPath = val.getStart().path; // コメント開始位置の配列
      const cEnPath = val.getEnd().path; // コメント終了位置の配列
      // console.log('コメントのパス：' + cStPath.toString() + ', ' + cEnPath.toString());

      if (aStPath.length != cStPath.length) {
        // 該当要素はコメントの範囲外
        // console.log('範囲外 pathの要素数が異なる');
      } else {
        // console.log('pathの要素数が一致');

        const cStASt = this._getPathArea(cStPath, aStPath);
        const cStAEn = this._getPathArea(cStPath, aEnPath);
        const cEnASt = this._getPathArea(cEnPath, aStPath);
        const cEnAEn = this._getPathArea(cEnPath, aEnPath);

        if (cStASt == 0 && cEnAEn == 0) {
          // 同じ
          //  ca         ac
          //  |[---------]|
          pt = 1;
          break;
        } else if (cStASt == 1 && cStAEn == -1 && cEnASt == 1 && cEnAEn == -1) {
          // 内側
          //  a      c         c      a
          //  [      |---------|      ]
          pt = 2;
          break;
        } else if (cStASt == -1 && cEnAEn == 1) {
          // 外から外
          //  c      a         a       c
          //  |------[---------]-------|
          pt = 3;
          break;
        } else if (cStASt == 0 && cEnAEn == 1) {
          // 前が同じ、後ろは外
          //  ca              a       c
          //  |[--------------]-------|
          pt = 4;
          break;
        } else if (cStASt == 0 && cEnASt == 1 && cEnAEn == -1) {
          // 前が同じ、後ろは中
          //  ca              c       a
          //  |[--------------|       ]
          pt = 5;
          break;
        } else if (cStASt == -1 && cEnAEn == 0) {
          // 後ろが同じ、前は外
          //  c      a         ac
          //  |------[---------]|
          pt = 6;
          break;
        } else if (cStASt == 1 && cStAEn == -1 && cEnAEn == 0) {
          // 後ろが同じ、前は中
          //  a      c         ac
          //  [      |---------]|
          pt = 7;
          break;
        } else if (cStASt == -1 && cEnASt == 1 && cEnAEn == -1) {
          // 前から途中まで
          //  c      a      c   a
          //  |------[------|   ]
          pt = 8;
          break;
        } else if (cStASt == 1 && cStAEn == -1 && cEnAEn == 1) {
          // 途中から外まで
          //  a    c          a       c
          //  [    |----------]-------|
          pt = 9;
          break;
        } else {
          // それ以外は範囲外
          //  c      c    a      a
          //  |------|    [      ]
          //  a      a    c      c
          //  [      ]    |------|
        }
      }
    }
    // console.log('結果 : ' + cmKey + ' => ' + pt.toString());
    return { pattern: pt, cmKey: cmKey };
  };

  // コメントとa要素のpathの位置関係を取得
  static _getPathArea(cPath, aPath) {
    if (cPath.toString() == aPath.toString()) {
      // pathは同じ
      return 0;
    }

    const cnt = aPath.length;
    for (var i = 0; i < cnt; i++) {
      const cp = cPath[i];
      const ap = aPath[i];

      if (cp < ap) {
        // コメントのpathが前
        return -1;
      }

      if (cp > ap) {
        // コメントのpathが後
        return 1;
      }
    }
    // pathは同じ
    return 0;
  }

  /**
   *
   * pタグ内にaタグが存在するか
   * aタグ内にインラインタグが存在する場合、複数に分かれてしまう。その場合は一つで良い
   *
   * @param {*} elementP
   * @returns
   */
  static _getAInfo = (elementP) => {
    let arrA = [];
    let idArr = [];
    elementP._children._nodes.forEach((element) => {
      let isA = false;
      let href = '';
      let aId = '';
      let stPath = null;
      let enPath = null;

      // href属性値が存在する場合、リンク
      if (element.hasAttribute('linkHref')) {
        const linkHref = String(element.getAttribute('linkHref'));
        if (linkHref !== '') {
          if (linkHref.substring(0, 1) === '#') {
            isA = true;
            href = linkHref;
            stPath = element.getPath();
          }
        }
      }

      // id属性値
      if (element.hasAttribute('htmlA')) {
        const htmlA = element.getAttribute('htmlA');
        if (htmlA.attributes) {
          if (htmlA.attributes.id) {
            aId = htmlA.attributes.id;
          }
        }
      }

      // リンクID配列(重複無し)
      if (isA) {
        const find = idArr.find((i) => i == href);
        if (find == undefined) {
          idArr.push(href);
        }

        // pタグ内の全リンクデータ(異なるリンクIDが混在)
        let item = {
          reference_id: href,
          a_id: aId,
          path: stPath,
          st_off: parseInt(element.startOffset),
          en_off: parseInt(element.endOffset),
        };
        arrA.push(item);
      }
    });

    const retArr = idArr.map((href_id) => {
      // リンクIDでまとめた配列
      const filtered = arrA.filter((item) => item.reference_id === href_id);
      //console.log(filtered);

      // startOffsetの最小値取得
      const minOffset = Math.min(...filtered.map((item) => item.st_off));
      // endOffsetの最大値取得
      const maxOffset = Math.max(...filtered.map((item) => item.en_off));

      // コメントエリアが関係しているかの情報を取得
      const cmMarkers = editor.model.markers;
      const cmInfo = this._hasComment(filtered[0].path, minOffset, maxOffset, cmMarkers);

      // 配列にセット
      const retItem = {
        reference_id: href_id,
        a_id: filtered[0].a_id,
        c_info: cmInfo,
      };
      return retItem;
    });
    // console.log(retArr);

    return retArr;
  };

  // JavaScript（Fetch）を利用した非同期通信 (jQueryを利用してajaxで通信しない)
  static _getApiKey = () => {
    // Cookie から API キーを取得
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const trimmedCookie = cookie.trim();
      const pattern = new RegExp('^api-key=(.*)$');
      const match = trimmedCookie.match(pattern);
      if (match) {
        return match[1];
      }
    }
    return '';
  };
  static _getTopUrl = () => {
    return location.origin;
  };
  static _getApiTopUrl = (apiBasePath) => {
    const topUrl = this._getTopUrl();
    let apiTopUrl = apiBasePath;
    return new URL(apiTopUrl, topUrl).href;
  };

  // modelFragment ⇒ textモデルの配列に変換
  // <a href="X" id="Y">aaaaaa</a> ⇒ この場合、TEXTモデルは一つ
  // <a href="X" id="Y">aaa<sup>bbb</sup>ccc</a> ⇒ この場合、TEXTモデルは3つとなる。共通の属性値はhrefとid
  // Pタグ内に複数のAタグがある場合もあるので、識別子としてlinkHrefも戻り値に持つ
  static _getTextNode = (modelFragment) => {
    const texts = [];
    let href = '';
    const nodes = modelFragment._children._nodes;
    nodes[0]._children._nodes.forEach((text) => {
      texts.push(text);
      href = text.getAttribute('linkHref');
    });
    return { href: href, texts: texts };
  };
}
